import Reflux from 'reflux';
import ProfileActions from '../actions/ProfileActions';
import AppActions from '../AppActions';
import axios from 'axios';
import history from '../history';

export default class ProfileStore extends Reflux.Store {
    constructor () {
        super();
        this.state = {
            profile: {},
            userTopics: [],
            userFavs: [],
            topsCount: 0,
            apiUrl: process.env.REACT_APP_API_URL + '/api',
            errorEditingScreenName: false
        };
        this.listenables = ProfileActions;
    }

    onGetProfileFavs (profileId) {
        return axios.get(`${this.state.apiUrl}/topiclists?conditions={"user":"${profileId}", "name":"favorites"}`)
          .then((favs) => {
              this.setState({userFavs: favs.data[0].topicNames});
          }).catch((error) => {
              console.error('onGetProfileTopics: ', error);
          });
    }

    onGetProfileTopics () {
        return axios.get(`${this.state.apiUrl}/usertopics?populate=createdBy&&sort=-createdAt&&conditions={"createdBy":"${this.state.profile._id}"}&&limit=6`)
          .then((userTopics) => {
              this.setState({userTopics: userTopics.data});
          }).catch((error) => {
              console.error('onGetProfileTopics: ', error);
          });
    }

    onGetMoreProfileTopics () {
        return axios.get(`${this.state.apiUrl}/usertopics?skip=${this.state.userTopics.length}&&limit=6&&populate=createdBy&&sort=-createdAt&&conditions={"createdBy":"${this.state.profile._id}"}`)
          .then((userTopics) => {
              this.setState({userTopics: this.state.userTopics.concat(userTopics.data)});
          }).catch((error) => {
              console.error('onGetProfileTopics: ', error);
          });
    }

    onGetProfileTopicsCount (profileId) {
        return axios.get(`${this.state.apiUrl}/usertopics?count=true&&conditions={"createdBy":"${profileId}"}`)
          .then((count) => {
              this.setState({topsCount: count.data});
          }).catch((error) => {
              console.error('onGetProfileTopics: ', error);
          });
    }

    onGetProfile (username) {
        return axios.get(`${this.state.apiUrl}/users?populate=following followers&&conditions={"username":"${username}"}`)
        .then((response) => {
            if (response.data[0]) {
                this.setState({profile: response.data[0]});
                this.onGetProfileTopics(response.data[0]._id);
                this.onGetProfileFavs(response.data[0]._id);
                this.onGetProfileTopicsCount(response.data[0]._id);
            } else {
                history.push('/notfound');
            }
        })
        .catch((error) => {
            console.error('profileError: ', error);
        });
    }

    onEditProfile (profile, userId) {
        return axios.put(this.state.apiUrl + '/users/' + userId, profile)
          .then((response) => {
              if (response.status !== 200) {
                  this.setState({errorEditingScreenName: true});
              } else {
                  let username = response.data.username;
                  AppActions.updateUsername(username);
                  ProfileActions.getProfile(username);
                  history.push('/p/' + username);
              }
          });
    }

    onClearProfile (username) {
        if (decodeURI(username) !== this.state.profile.username) {
            this.setState({profile: {}, userTopics: [], userFavs: [], topsCount: 0});
        }
    }
}



// WEBPACK FOOTER //
// ./src/stores/ProfileStore.js